import relu from '../Images/Demos/Relu.png';
import CarForm from '../Images/Demos/Car_Form_card.png';
import E_Commerce from '../Images/Demos/E-Commerce.png';
import NightAdmin from '../Images/Demos/Night Admin.png';
import BillsDashboard from '../Images/Demos/Bills Dashboard.png';
import DashBoard from '../Images/Demos/DashBoard.png';
import UploadForm from '../Images/Demos/Upload Form.png';
import SmartDashboard from '../Images/Demos/Smart Dashboard.png';
import AnalysisDB from '../Images/Demos/Analysis dashboard.png';
import GP from '../Images/Demos/GP.png';
import H_Scrub from "../Images/Demos/Scrub shopping.png";
import Gosto from "../Images/Demos/Gosto.png";
import Auction from "../Images/Demos/Auction World.png";
import Loukma from "../Images/Demos/Cashier System.png";
import Cyper from "../Images/Demos/System Cafe.png";
import cartemplate from "../Images/Demos/Cars Shopping.png";
import ShoesWebsite from "../Images/Demos/Shoes Website.png";

const DemoImages = [
  {
    project:cartemplate,
    link:'https://car-template-rho.vercel.app/',
    descEn:'E-commerce Website',
    descAr:'متجر الكتروني',
    textEn:'Visit Now',
    textAr:'رابط الموقع',
  },
  {
    project:ShoesWebsite,
    link:'https://nike-templete.vercel.app/',
    descEn:'E-commerce Website',
    descAr:'متجر الكتروني',
    textEn:'Visit Now',
    textAr:'رابط الموقع',
  },
  {
    // Scrub
    project:H_Scrub,
    // link:'https://scrub-shopping.vercel.app/',
    descEn:'E-commerce Website',
    descAr:'متجر الكتروني',
    // textEn:'Visit Now',
    // textEn:'not available',
    // textAr:'رابط الموقع',
    // textAr:'الرابط غير متاح',
  },
  {
    project:relu,
    // link:'https://relu-client.vercel.app/',
    descEn:'E-commerce Website',
    descAr:'متجر الكتروني',
    // textEn:'Visit Now',
    // textEn:'not available',
    // textAr:'رابط الموقع',
    // textAr:'الرابط غير متاح',
    
  },
  {
    project:Gosto,
    descEn:'E-commerce Website',
    descAr:'متجر الكتروني',
    // textEn:'not available',
    // textAr:'الرابط غير متاح',
  },
  {
    project:Auction,
    descEn:'E-commerce Website',
    descAr:'متجر الكتروني',
    // textEn:'not available',
    // textAr:'الرابط غير متاح',

  },
  {
    project:Cyper,
    descEn:'Management system',
    descAr:'نظام أداري',
    // textEn:'not available',
    // textAr:'الرابط غير متاح',
  },
  {
    project:Loukma,
    descEn:'Cashier system',
    descAr:'نظام محاسبة كاشير',
    // textEn:'Not available',
    // textAr:'الرابط غير متاح',

  },
  {
    project:CarForm,
    // link:'',
    descEn:'Form for collecting data',
    descAr:'نموذج لجمع البيانات',
    // textEn:'Visit Now',
    // textAr:'رابط الموقع',
  },{
    project:E_Commerce,
    // link:'',
    descEn:'E-commerce Website',
    descAr:'متجر الكتروني',
    // textEn:'Visit Now',
    // textAr:'رابط الموقع',
  },{
    project:NightAdmin,
    // link:'',
    descEn:'Smart Admin dashboard',
    descAr:'لوحة تحكم الإدارة الذكية ',
    // textEn:'Visit Now',
    // textAr:'رابط الموقع',
  },{
    project:BillsDashboard,
    // link:'',
    descEn:'Invoice review system',
    descAr:'نظام مراجعة فواتير ',
    // textEn:'Visit Now',
    // textAr:'رابط الموقع',
  },{
    project:DashBoard,
    // link:'',
    descEn:'Smart Admin Control panel ',
    descAr:'لوحة تحكم الإدارة الذكية',
    // textEn:'Visit Now',
    // textAr:'رابط الموقع',
  },{
    project:UploadForm,
    // link:'',
    descEn:'Page for upload data ',
    descAr:'صفحة لتحميل البيانات',
    // textEn:'Visit Now',
    // textAr:'رابط الموقع',
  },{
    project:SmartDashboard,
    // link:'',
    descEn:'Smart Control panel',
    descAr:'لوحة تحكم الإدارة الذكية',
    // textEn:'Visit Now',
    // textAr:'رابط الموقع',
  },{
    project:AnalysisDB,
    // link:'',
    descEn:'Smart Control panel',
    descAr:'لوحة تحكم الإدارة الذكية',
    // textEn:'Visit Now',
    // textAr:'رابط الموقع',
  },{
    project:GP,
    // link:'',
    descEn:'Smart Garage System',
    descAr:'نظام المرآب الذكي',
    // textEn:'Visit Now',
    // textAr:'رابط الموقع',
  },
];
export default DemoImages